import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { createSelector } from "reselect";
import type { RootState } from "../store";

interface QlikObject {
  name: string;
  object: any;
}

interface QlikState {
  qlikObjects: QlikObject[];
  qlikHyperCubesData: Record<string, any>;
}

const initialState: QlikState = {
  qlikObjects: [],
  qlikHyperCubesData: {},
};

const qlikObjectSlice = createSlice({
  name: "qlikObject",
  initialState,
  reducers: {
    // Mutation to add a Qlik object
    setQlikObject(state, action: PayloadAction<{ appName: string, name: string; object: any }>) {
      // state.qlikObjects.push(action.payload);
      const idx = state.qlikObjects.findIndex(qlik => qlik.name === action.payload.name);
        if (idx !== -1) {
          // Replace existing object
          state.qlikObjects[idx] = action.payload;
        } else {
          // Add new object
          state.qlikObjects.push(action.payload);
        }
    },
    removeQlikObject: (state) => {
      state.qlikObjects = []; // Clear all Qlik objects
    },
    setHyperCubeData(
      state,
      action: PayloadAction<{ name: string; hyperCubeCustomId: string, hyperCube: any, hyperCubeId: string }>
    ) {
      const { name, hyperCubeCustomId, hyperCube, hyperCubeId } = action.payload;
      // Initialize nested structure if it doesn't exist
      if (!state.qlikHyperCubesData[name]) {
        state.qlikHyperCubesData[name] = {};
      }
      
      if (!state.qlikHyperCubesData[name][hyperCubeCustomId]) {
        state.qlikHyperCubesData[name][hyperCubeCustomId] = {};
      }
      for (const key in hyperCube) {
        state.qlikHyperCubesData[name][hyperCubeCustomId]= {...state.qlikHyperCubesData[name][hyperCubeCustomId]}
        state.qlikHyperCubesData[name][hyperCubeCustomId][key] = hyperCube[key];
      }
      //Adding hyperCubeId to the hyperCube as array of objects
      // if(state.qlikHyperCubesData[name]?.hyperCubeIds === undefined) {
      //   state.qlikHyperCubesData[name].hyperCubeIds = []
      // };
      // // Avoid pushing duplicate hyperCubeIds
      // if (!state.qlikHyperCubesData[name].hyperCubeIds.includes(hyperCubeId)) {
      //   state.qlikHyperCubesData[name].hyperCubeIds.push(hyperCubeId);
      // }
      //Adding hyperCubeCustomId to the hyperCube
      if(state.qlikHyperCubesData[name]?.hyperCubeCustomIds === undefined) {
        state.qlikHyperCubesData[name].hyperCubeCustomIds = []
      };
      // Avoid pushing duplicate hypercubeIds
      if (!state.qlikHyperCubesData[name].hyperCubeCustomIds.includes(hyperCubeCustomId)) {
        state.qlikHyperCubesData[name].hyperCubeCustomIds.push(hyperCubeCustomId);
      }
    },
  },
});

// Actions
export const { setQlikObject, removeQlikObject, setHyperCubeData } = qlikObjectSlice.actions;

// Reducer
export default qlikObjectSlice.reducer;

// Selectors
export const selectQlikObjects = (state: RootState) => state.qlikObject.qlikObjects;

// Memoized selector to get a Qlik object by name
export const selectQlikObjectByName = createSelector(
  [selectQlikObjects, (_: RootState, name: string) => name],
  (qlikObjects, name) => qlikObjects.find((qlik:any) => qlik.name === name)?.object ?? null
);

export type { QlikState, QlikObject };